/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/api/v1/sportData/player/details": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 获取多个球员详情
         * @description 根据多个球员ID获取其详细信息
         */
        post: operations["playerDetails"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/match/getTournamentAggByIds": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 根据比赛id获取赛事聚合信息
         * @description 根据比赛的ID获取其详细信息
         */
        get: operations["getTournamentAggByIds"];
        put?: never;
        /**
         * 根据比赛id获取赛事聚合信息(POST)
         * @description 根据比赛的ID获取其详细信息
         */
        post: operations["getTournamentAggByIdsPost"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/match/details": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 获取多个比赛详情
         * @description 根据多个比赛的ID获取其详细信息
         */
        post: operations["matchDetails"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/i18n": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 运动数据多语言翻译
         * @description 多语言翻译
         */
        post: operations["i18nTranslate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/recommend/topMatches": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 顶级活动
         * @description 顶级活动
         */
        get: operations["getSportDataVaixTopMatches"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/recommend/sports": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 运动类型
         * @description 运动类型
         */
        get: operations["getSports"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/recommend/liveEvent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 顶级活动
         * @description 顶级活动
         */
        get: operations["getLiveEvent"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/recommend/hotMatches": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 热门比赛
         * @description 热门比赛
         */
        get: operations["getHotMatches"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/recommend/hotCombosMatches": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * hotCombosMatches
         * @description hotCombosMatches
         */
        get: operations["getHotCombosMatches"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/sport/tree": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取运动项目树
         * @description 获取所有运动、分类、赛事的完整层级结构
         */
        get: operations["getSportDataSportTree"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/sport/recommend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取运动推荐数据
         * @description 根据比赛状态获取运动项目的推荐列表
         */
        get: operations["sportRecommend"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/sport/outRightTree": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取运动项目树
         * @description 获取所有运动、分类、赛事的完整层级结构
         */
        get: operations["outRightTree"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/sport/algoSport": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 算法运动类型推荐
         * @description 算法运动类型推荐
         */
        get: operations["algoSport"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/recommend/bettingHighlight": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * bettingHighlight
         * @description bettingHighlight
         */
        get: operations["getBettingHighlight"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/outright/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取冠军盘搜索数据
         * @description 根据运动项目ID搜索冠军盘，并按赛事分组返回
         */
        get: operations["outrightSearch"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/match/{matchId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取比赛详情
         * @description 根据比赛的ID获取其详细信息
         */
        get: operations["matchDetail"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/match/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取比赛搜索数据
         * @description 根据运动项目、比赛状态和时间搜索比赛，并按赛事分组返回
         */
        get: operations["getSportDataMatchSearch"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/match/matchPlayers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 根据比赛ID获取双方球员列表
         * @description 返回主队和客队的球员详情
         */
        get: operations["matchPlayers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/match/checkMatch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 判断是否有比赛和冠军盘
         * @description 判断是否有比赛和冠军盘
         */
        get: operations["checkMatch"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/match/algoSearch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 算法搜索推荐
         * @description 算法搜索推荐
         */
        get: operations["algoSearch"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/league/algoLeague": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 算法联赛推荐
         * @description 算法联赛推荐
         */
        get: operations["algoLeague"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/recommend/v2HotMatches": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 热门比赛
         * @description 热门比赛
         */
        get: operations["getSportDataVaixV2HotMatches"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/recommend/popularLeague": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 热门比赛
         * @description 热门比赛
         */
        get: operations["getSportDataVaixPopularLeague"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/recommend/popularEvents": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 热门比赛
         * @description 热门比赛
         */
        get: operations["getSportDataVaixPopularEvents"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/recommend/trendingSport": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 热门比赛
         * @description 热门比赛
         */
        get: operations["getSportDataVaixTrendingSport"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 搜索
         * @description 根据关键词搜索
         */
        get: operations["getSportDataSearch"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/recommend/favorite": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * favorite
         * @description favorite
         */
        get: operations["getRecommendVaixFavorite"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/sportData/match/getTournamentMatchByIds": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Get tournament aggregation information by match ID (POST)
         * @description Get detailed information based on match ID
         */
        post: operations["createSportDataMatchGetTournamentMatchByIds"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /**
         * @description 多个球员详情请求
         * @example {
         *       "playerIds": [
         *         "sr:player:1005347",
         *         "sr:player:1005355",
         *         "sr:player:1005359",
         *         "sr:player:1005361",
         *         "sr:player:1005369",
         *         "sr:player:1005387",
         *         "sr:player:1005389",
         *         "sr:player:1005393",
         *         "sr:player:1005409",
         *         "sr:player:1005411",
         *         "sr:player:1005419",
         *         "sr:player:1005421"
         *       ]
         *     }
         */
        "com.bz.league.sports.search.api.request.PlayerDetailRequest": {
            /**
             * @description 球员URN列表
             * @example [
             *       "sr:player:100000",
             *       "sr:player:1000001"
             *     ]
             */
            playerIds: string[];
        };
        "com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.PlayerDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.PlayerDto"][];
        };
        /** @description 球员详情数据 */
        "com.bz.league.sports.search.api.dto.PlayerDto": {
            /**
             * @description 球员ID
             * @example sr:player:12345
             */
            id: string;
            /**
             * @description 姓名
             * @example Erling Haaland
             */
            name: string;
            /**
             * @description 全名
             * @example Erling Braut Haaland
             */
            fullName: string;
            /**
             * @description 昵称
             * @example Haaland
             */
            nickname: string;
            /**
             * @description 性别
             * @example male
             */
            gender: string;
            /**
             * Format: int32
             * @description 身高（厘米）
             * @example 194
             */
            height: number;
            /**
             * Format: int32
             * @description 体重（千克）
             * @example 88
             */
            weight: number;
            /**
             * Format: int32
             * @description 球衣号码
             * @example 9
             */
            jerseyNumber: number;
            /**
             * @description 类型（如 position 或角色）
             * @example forward
             */
            type: string;
            /**
             * Format: int64
             * @description 出生日期（毫秒时间戳）
             * @example 946684800000
             */
            dateOfBirth: number;
            /**
             * @description 国家代码
             * @example NO
             */
            countryCode: string;
            /**
             * @description 国籍
             * @example Norway
             */
            nationality: string;
        };
        /** @description Multiple match detail request */
        "com.bz.league.sports.search.api.request.MatchDetailRequest": {
            /**
             * Format: int32
             * @description Odds display mode, 0: standard (default), 1: 3-way, 2: professional
             * @example 1
             */
            marketMode?: number;
            /**
             * Format: int32
             * @description League display mode, 1: By league, 0: By time
             * @example 1
             */
            leagueMode?: number;
            /**
             * @description Match URN list
             * @example [
             *       "sr:match:12345678",
             *       "sr:match:23456789"
             *     ]
             */
            matchIds: string[];
        };
        "com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.TournamentAggMatchHitDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.TournamentAggMatchHitDto"][];
        };
        "com.bz.league.sports.search.api.dto.EventClockDto": {
            matchTime: string;
            stoppageTime: string;
            stoppageTimeAnnounced: string;
            remainingTime: string;
            remainingTimeInPeriod: string;
            stopped: boolean;
        };
        "com.bz.league.sports.search.api.dto.MatchPeriodScoreDto": {
            /** Format: int32 */
            matchStatusCode: number;
            /** Format: int32 */
            number: number;
            homeScore: number;
            awayScore: number;
        };
        "com.bz.league.sports.search.api.dto.SportEventStatusDto": {
            clock: components["schemas"]["com.bz.league.sports.search.api.dto.EventClockDto"];
            periodScores: components["schemas"]["com.bz.league.sports.search.api.dto.MatchPeriodScoreDto"][];
            statistics: components["schemas"]["com.bz.league.sports.search.api.dto.StatisticsDto"];
            /** Format: int32 */
            status: number;
            statusName: string;
            /** Format: int32 */
            matchStatus: number;
            matchStatusName: string;
            homeScore: number;
            awayScore: number;
            /** Format: int32 */
            homePenaltyScore: number;
            /** Format: int32 */
            awayPenaltyScore: number;
            /** Format: int32 */
            homeGamescore: number;
            /** Format: int32 */
            awayGamescore: number;
            /** Format: int32 */
            homeLegscore: number;
            /** Format: int32 */
            awayLegscore: number;
            /** Format: int32 */
            currentServer: number;
            expediteMode: boolean;
            tiebreak: boolean;
            /** Format: int32 */
            homeSuspend: number;
            /** Format: int32 */
            awaySuspend: number;
            /** Format: int32 */
            balls: number;
            /** Format: int32 */
            strikes: number;
            /** Format: int32 */
            outs: number;
            bases: string;
            /** Format: int32 */
            homeBatter: number;
            /** Format: int32 */
            awayBatter: number;
            pitcher: string;
            batter: string;
            /** Format: int32 */
            pitchCount: number;
            /** Format: int32 */
            pitchesSeen: number;
            /** Format: int32 */
            totalHits: number;
            /** Format: int32 */
            totalPitches: number;
            /** Format: int32 */
            possession: number;
            /** Format: int32 */
            position: number;
            /** Format: int32 */
            get_try: number;
            /** Format: int32 */
            yards: number;
            /** Format: int32 */
            get_throw: number;
            /** Format: int32 */
            visit: number;
            /** Format: int32 */
            remainingReds: number;
            /** Format: int32 */
            delivery: number;
            /** Format: int32 */
            homeRemainingBowls: number;
            /** Format: int32 */
            awayRemainingBowls: number;
            /** Format: int32 */
            currentEnd: number;
            /** Format: int32 */
            innings: number;
            /** Format: int32 */
            over: number;
            /** Format: int32 */
            homePenaltyRuns: number;
            /** Format: int32 */
            awayPenaltyRuns: number;
            /** Format: int32 */
            homeDismissals: number;
            /** Format: int32 */
            awayDismissals: number;
            /** Format: int32 */
            currentCtTeam: number;
            /** Format: int32 */
            periodOfLeader: number;
            /** Format: int32 */
            homeDriveCount: number;
            /** Format: int32 */
            awayDriveCount: number;
            /** Format: int32 */
            homePlayCount: number;
            /** Format: int32 */
            awayPlayCount: number;
            /** Format: int32 */
            cricketHomeOver: number;
            /** Format: int32 */
            cricketHomeDelivery: number;
            /** Format: int32 */
            cricketAwayOver: number;
            /** Format: int32 */
            cricketAwayDelivery: number;
        };
        /** @description Live stream DTO */
        "com.bz.league.sports.search.api.dto.StreamsDto": {
            /**
             * @description Live stream URL
             * @example https://example.com/live_stream.m3u8
             */
            streamUrl: string;
            /**
             * @description Live stream cover URL
             * @example https://example.com/live_cover.jpg
             */
            streamCoverUrl: string;
            /**
             * Format: int32
             * @description Live stream status
             */
            streamStatus: number;
            /**
             * Format: int32
             * @description Live stream line
             */
            line: number;
        };
        /** @description Match aggregation DTO grouped by tournament, containing tournament, category, sport and associated match list */
        "com.bz.league.sports.search.api.dto.TournamentAggMatchHitDto": {
            /**
             * @description Aggregation ID
             * @example sr:tournament:12345
             */
            id: string;
            /**
             * @description Tournament name
             * @example Premier League
             */
            name: string;
            /**
             * @description Tournament Chinese name
             * @example Premier League
             */
            nameZh: string;
            /**
             * @description Tournament short name
             * @example PL
             */
            shortName: string;
            /**
             * @description Tournament abbreviation
             * @example EPL
             */
            abbreviation: string;
            /**
             * @description Tournament logo URL
             * @example https://example.com/tournament_logo.png
             */
            logoUrl: string;
            /**
             * @description Dark tournament logo
             * @example https://example.com/epl_dark_logo.png
             */
            darkLogoUrl: string;
            /**
             * @description Light tournament logo
             * @example https://example.com/epl_light_logo.png
             */
            lightLogoUrl: string;
            /**
             * Format: int32
             * @description League level, -1: uninitialized
             * @example 1
             */
            level: number;
            /**
             * Format: int32
             * @description Gender: 0-male, 1-female, 2-unknown
             * @example 0
             */
            gender: number;
            /**
             * @description Associated tournament current season ID
             * @example sr:season:93931
             */
            currentSeasonId: string;
            /**
             * Format: int32
             * @description League type: -1 uninitialized, 0-unknown, 1-league, 2-cup, 3-friendly
             * @example 1
             */
            type: number;
            /**
             * Format: int32
             * @description Sort value
             * @example 10
             */
            sort: number;
            /**
             * @description Whether it is a national team match
             * @example true
             */
            isCountry: boolean;
            /**
             * @description Associated category ID
             * @example sr:category:29
             */
            categoryId: string;
            /**
             * @description Associated category name
             * @example England
             */
            categoryName: string;
            /**
             * @description Associated category Chinese name
             * @example England
             */
            categoryNameZh: string;
            /**
             * @description Associated category Logo URL
             * @example https://example.com/category_logo.png
             */
            categoryLogoUrl: string;
            /**
             * @description Associated category country/region code
             * @example ENG
             */
            categoryCountryCode: string;
            /**
             * @description Associated sport ID
             * @example sr:sport:1
             */
            sportId: string;
            /**
             * @description Sport name
             * @example Football
             */
            sportName: string;
            /**
             * @description Sport Chinese name
             * @example Football
             */
            sportNameZh: string;
            /**
             * @description Sport Logo URL
             * @example https://example.com/sport_logo.png
             */
            sportLogoUrl: string;
            /**
             * Format: int64
             * @description Associated match count
             * @example 10
             */
            matchCount: number;
            /** @description Associated match list */
            matches: components["schemas"]["com.bz.league.sports.search.api.dto.BaseTournamentAggMatchHitDto$SeasonMatchDocumentInnerDto"][];
        };
        /** @description 赛季比赛文档DTO，包含赛季信息和比赛详细数据 */
        "com.bz.league.sports.search.api.dto.TournamentAggMatchHitDto$SeasonMatchDocumentInnerDto": {
            /**
             * @description 赛季ID
             * @example sr:season:93931
             */
            seasonId: string;
            /**
             * @description 赛季名称
             * @example Premier League 22/23
             */
            seasonName: string;
            /**
             * @description 赛季年份
             * @example 22/23
             */
            seasonYear: string;
            /**
             * @description 比赛ID或URN
             * @example sr:match:37939735
             */
            id: string;
            /**
             * @description 体育项目ID
             * @example sr:sport:1
             */
            sportId: string;
            /**
             * @description 比赛名称
             * @example Arsenal vs Manchester United
             */
            name: string;
            /**
             * @description 主队ID
             * @example sr:competitor:42
             */
            homeId: string;
            /**
             * @description 主队名称
             * @example Arsenal
             */
            homeName: string;
            /**
             * @description 主队简称
             * @example ARS
             */
            homeShortName: string;
            /**
             * @description 主队Logo URL
             * @example https://example.com/arsenal_logo.png
             */
            homeLogoUrl: string;
            /** @description 主队球衣 */
            homeJersey: string;
            /**
             * @description 主队国家/地区代码
             * @example ENG
             */
            homeCountryCode: string;
            /**
             * @description 客队ID
             * @example sr:competitor:35
             */
            awayId: string;
            /**
             * @description 客队名称
             * @example Manchester United
             */
            awayName: string;
            /**
             * @description 客队简称
             * @example MU
             */
            awayShortName: string;
            /**
             * @description 客队Logo URL
             * @example https://example.com/mu_logo.png
             */
            awayLogoUrl: string;
            /** @description 客队球衣 */
            awayJersey: string;
            /**
             * @description 客队国家/地区代码
             * @example ENG
             */
            awayCountryCode: string;
            /**
             * @description 场馆ID
             * @example sr:venue:123
             */
            venueId: string;
            /**
             * @description 场馆名称
             * @example Emirates Stadium
             */
            venueName: string;
            /**
             * @description 裁判ID
             * @example sr:referee:456
             */
            refereeId: string;
            /**
             * @description 裁判名称
             * @example Anthony Taylor
             */
            refereeName: string;
            /**
             * @description 比赛类型
             * @example match
             */
            type: string;
            /**
             * @description 分组ID
             * @example sr:group:789
             */
            groupId: string;
            /**
             * @description 分组名称
             * @example Group A
             */
            groupName: string;
            /**
             * @description 阶段（例如：小组赛、淘汰赛）
             * @example Group Stage
             */
            phase: string;
            /**
             * @description 其他比赛ID
             * @example sr:match:99999
             */
            otherMatchId: string;
            /**
             * @description 联赛轮次
             * @example 21
             */
            tournamentRound: string;
            /**
             * Format: int64
             * @description 计划开始时间（Unix时间戳，毫秒）
             * @example 1674408600000
             */
            scheduledTime: number;
            /**
             * Format: int64
             * @description 计划结束时间（Unix时间戳，毫秒）
             * @example 1674415800000
             */
            scheduledEndTime: number;
            /**
             * Format: int32
             * @description 比赛状态
             */
            status: number;
            /** @description 比赛状态名称 */
            statusName: string;
            /**
             * Format: int32
             * @description 比赛状态
             */
            matchStatus: number;
            /** @description 比赛状态名称 */
            matchStatusName: string;
            sportEventStatus: components["schemas"]["com.bz.league.sports.search.api.dto.SportEventStatusDto"];
            /**
             * @description 是否有雷达滚球赔率
             * @example true
             */
            hasRadarLiveOdds: boolean;
            /**
             * @description 是否有雷达赛前盘赔率
             * @example true
             */
            hasRadarPreMatchOdds: boolean;
            marketBatchResponse: components["schemas"]["com.bz.odds.api.dto.MarketBatchResponse"];
            /** @description 直播流列表 */
            streamsList: components["schemas"]["com.bz.league.sports.search.api.dto.StreamsDto"][];
        };
        "com.bz.odds.api.dto.GroupConfigDTO": {
            key: string;
            /** Format: int32 */
            index: number;
            name: string;
        };
        /** @description Market batch response data from market service */
        "com.bz.odds.api.dto.MarketBatchResponse": {
            marketList: components["schemas"]["com.bz.odds.api.dto.response.MarketResponse"][];
            /** Format: int32 */
            totalMarkets: number;
            hasOtherBalance: boolean;
        };
        /**
         * 盘口投注项赔率列表
         * @description 盘口投注项赔率列表
         */
        "com.bz.odds.api.dto.MarketSpecifierDTO": {
            specifiers: string;
            /** Format: int32 */
            status: number;
            outcomes: components["schemas"]["com.bz.odds.api.dto.OutcomeDTO"][];
        };
        "com.bz.odds.api.dto.OptionDTO": {
            groupName: string;
            name: string;
            type: string;
            content: Record<string, never>;
        };
        "com.bz.odds.api.dto.OutcomeDTO": {
            code: string;
            outcomeId: string;
            outcomeName: string;
            displayName: string;
            odds: number;
            /** Format: int32 */
            active: number;
            /** Format: int64 */
            updateTime: number;
            /** Format: int32 */
            phase: number;
            frontIndex: string;
        };
        /** 按玩法类型分组的赔率 */
        "com.bz.odds.api.dto.response.MarketResponse": {
            /**
             * 盘口ID
             * @description 盘口ID
             */
            marketId: string;
            /**
             * 玩法名称
             * @description 玩法名称
             */
            marketName: string;
            /**
             * 玩法显示名称
             * @description 玩法显示名称
             */
            displayName: string;
            marketTabType: string;
            colNameList: string[];
            /** Format: int32 */
            colSize: number;
            groupConfig: components["schemas"]["com.bz.odds.api.dto.GroupConfigDTO"];
            options: components["schemas"]["com.bz.odds.api.dto.OptionDTO"][];
            /**
             * 盘口投注项赔率列表
             * @description 盘口投注项赔率列表
             */
            marketSpecifierList: components["schemas"]["com.bz.odds.api.dto.MarketSpecifierDTO"][];
        };
        "com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.SeasonMatchDocumentDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.SeasonMatchDocumentDto"][];
        };
        /** @description 赛季比赛文档DTO，包含比赛的完整详细信息 */
        "com.bz.league.sports.search.api.dto.SeasonMatchDocumentDto": {
            /**
             * @description 体育项目ID
             * @example sr:sport:1
             */
            sportId: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            sportName: string;
            /**
             * @description 体育项目中文名称
             * @example 足球
             */
            sportNameZh: string;
            /**
             * @description 体育项目Logo URL
             * @example https://example.com/sport_logo.png
             */
            sportLogoUrl: string;
            /**
             * @description 赛事类别ID
             * @example sr:category:29
             */
            categoryId: string;
            /**
             * @description 赛事类别名称
             * @example England
             */
            categoryName: string;
            /**
             * @description 赛事类别中文名称
             * @example 英格兰
             */
            categoryNameZh: string;
            /**
             * @description 赛事类别国家代码
             * @example ENG
             */
            categoryCountryCode: string;
            /**
             * @description 赛事类别Logo URL
             * @example https://example.com/category_logo.png
             */
            categoryLogoUrl: string;
            /**
             * @description 联赛/锦标赛ID
             * @example sr:tournament:17
             */
            tournamentId: string;
            /**
             * @description 联赛/锦标赛名称
             * @example Premier League
             */
            tournamentName: string;
            /**
             * @description 联赛/锦标赛中文名称
             * @example 英超联赛
             */
            tournamentNameZh: string;
            /**
             * @description 联赛/锦标赛简称
             * @example 英超
             */
            tournamentShortName: string;
            /**
             * @description 联赛/锦标赛Logo URL
             * @example https://example.com/tournament_logo.png
             */
            tournamentLogoUrl: string;
            /**
             * Format: int32
             * @description 联赛/锦标赛级别
             * @example 1
             */
            tournamentLevel: number;
            /**
             * Format: int32
             * @description 联赛/锦标赛性别（0:男, 1:女, 2:未知）
             * @example 0
             */
            tournamentGender: number;
            /**
             * Format: int32
             * @description 联赛/锦标赛类型 (1:联赛, 2:杯赛)
             * @example 1
             */
            tournamentType: number;
            /**
             * Format: int32
             * @description 排序值
             * @example 10
             */
            tournamentSort: number;
            /**
             * @description 是否为国家比赛
             * @example true
             */
            tournamentIsCountry: boolean;
            /**
             * @description 赛季ID
             * @example sr:season:93931
             */
            seasonId: string;
            /**
             * @description 赛季名称
             * @example Premier League 22/23
             */
            seasonName: string;
            /**
             * @description 赛季年份
             * @example 22/23
             */
            seasonYear: string;
            /**
             * @description 比赛ID或URN
             * @example sr:match:37939735
             */
            id: string;
            /**
             * @description 比赛名称
             * @example Arsenal vs Manchester United
             */
            name: string;
            /**
             * @description 主队ID
             * @example sr:competitor:42
             */
            homeId: string;
            /**
             * @description 主队名称
             * @example Arsenal
             */
            homeName: string;
            /**
             * @description 主队简称
             * @example ARS
             */
            homeShortName: string;
            /**
             * @description 主队Logo URL
             * @example https://example.com/arsenal_logo.png
             */
            homeLogoUrl: string;
            /** @description 主队球衣 */
            homeJersey: string;
            /**
             * @description 主队国家代码
             * @example ENG
             */
            homeCountryCode: string;
            /**
             * @description 客队ID
             * @example sr:competitor:35
             */
            awayId: string;
            /**
             * @description 客队名称
             * @example Manchester United
             */
            awayName: string;
            /**
             * @description 客队简称
             * @example MU
             */
            awayShortName: string;
            /**
             * @description 客队Logo URL
             * @example https://example.com/mu_logo.png
             */
            awayLogoUrl: string;
            /** @description 客队球衣 */
            awayJersey: string;
            /**
             * @description 客队国家代码
             * @example ENG
             */
            awayCountryCode: string;
            /**
             * @description 场馆ID
             * @example sr:venue:123
             */
            venueId: string;
            /**
             * @description 场馆名称
             * @example Emirates Stadium
             */
            venueName: string;
            /**
             * @description 裁判ID
             * @example sr:referee:456
             */
            refereeId: string;
            /**
             * @description 裁判名称
             * @example Anthony Taylor
             */
            refereeName: string;
            /**
             * @description 比赛类型
             * @example match
             */
            type: string;
            /**
             * @description 分组ID
             * @example sr:group:789
             */
            groupId: string;
            /**
             * @description 分组名称
             * @example Group A
             */
            groupName: string;
            /**
             * @description 阶段（例如：小组赛、淘汰赛）
             * @example Group Stage
             */
            phase: string;
            /**
             * @description 其他比赛ID
             * @example sr:match:99999
             */
            otherMatchId: string;
            /**
             * @description 联赛轮次
             * @example 21
             */
            tournamentRound: string;
            /**
             * Format: int64
             * @description 计划开始时间（Unix时间戳，毫秒）
             * @example 1674408600000
             */
            scheduledTime: number;
            /**
             * Format: int64
             * @description 计划结束时间（Unix时间戳，毫秒）
             * @example 1674415800000
             */
            scheduledEndTime: number;
            /**
             * Format: int32
             * @description 比赛状态
             */
            status: number;
            /** @description 比赛状态名称 */
            statusName: string;
            /**
             * Format: int32
             * @description 比赛状态
             */
            matchStatus: number;
            /** @description 比赛状态名称 */
            matchStatusName: string;
            sportEventStatus: components["schemas"]["com.bz.league.sports.search.api.dto.SportEventStatusDto"];
            marketBatchResponse: components["schemas"]["com.bz.odds.api.dto.MarketBatchResponse"];
            /**
             * @description 是否有雷达滚球赔率
             * @example true
             */
            hasRadarLiveOdds: boolean;
            /**
             * @description 是否有雷达赛前盘赔率
             * @example true
             */
            hasRadarPreMatchOdds: boolean;
            /** @description 直播流列表 */
            streamsList: components["schemas"]["com.bz.league.sports.search.api.dto.StreamsDto"][];
        };
        /**
         * @description 国际化多语言翻译请求参数
         * @example {
         *       "urnIds": [
         *         "sr:match:63377631",
         *         "sr:match:10015443",
         *         "sr:match:10015455",
         *         "sr:match:10033559",
         *         "sr:match:10041663",
         *         "sr:match:10041999",
         *         "sr:match:10046279",
         *         "sr:match:10046463",
         *         "sr:match:10114171",
         *         "sr:match:10141817",
         *         "sr:match:10158927",
         *         "sr:match:10159925",
         *         "sr:match:10166645",
         *         "sr:match:10166647",
         *         "sr:match:10166673",
         *         "sr:match:10186187",
         *         "sr:match:10186193",
         *         "sr:match:10191215",
         *         "sr:match:10191219",
         *         "sr:match:10191221",
         *         "sr:match:10191223",
         *         "sr:match:10191235",
         *         "sr:match:10191243",
         *         "sr:match:10191251",
         *         "sr:match:10191253",
         *         "sr:match:10201345",
         *         "sr:match:10239807",
         *         "sr:match:10239809",
         *         "sr:match:10266847",
         *         "sr:match:10266849",
         *         "sr:match:10267361",
         *         "sr:match:10272727",
         *         "sr:match:10272931",
         *         "sr:match:10289815",
         *         "sr:match:10289817",
         *         "sr:match:10297887",
         *         "sr:match:10309833",
         *         "sr:match:10309835",
         *         "sr:match:10309873",
         *         "sr:match:10309945",
         *         "sr:match:10309947",
         *         "sr:match:10309967",
         *         "sr:match:10309969",
         *         "sr:match:10309997",
         *         "sr:match:10310003",
         *         "sr:match:10310005",
         *         "sr:match:10310007",
         *         "sr:match:10310011",
         *         "sr:match:10310013",
         *         "sr:match:10315809",
         *         "sr:match:10322203",
         *         "sr:match:10322205",
         *         "sr:match:10322207",
         *         "sr:match:10322215",
         *         "sr:match:10322219",
         *         "sr:match:10322221",
         *         "sr:match:10322223",
         *         "sr:match:10323969",
         *         "sr:match:10324033",
         *         "sr:match:10324109",
         *         "sr:match:10325607",
         *         "sr:match:10325609",
         *         "sr:match:10342945",
         *         "sr:match:10343532",
         *         "sr:match:10343540",
         *         "sr:match:10346902",
         *         "sr:match:10347878",
         *         "sr:match:10361406",
         *         "sr:match:10364456",
         *         "sr:match:10364694",
         *         "sr:match:10364696",
         *         "sr:match:10364814",
         *         "sr:match:10366466",
         *         "sr:match:10366984",
         *         "sr:match:10367292",
         *         "sr:match:10367294",
         *         "sr:match:10367300",
         *         "sr:match:10367302",
         *         "sr:match:10382054",
         *         "sr:match:10384234",
         *         "sr:match:10384236",
         *         "sr:match:10384238",
         *         "sr:match:10384240",
         *         "sr:match:10384246",
         *         "sr:match:10384248",
         *         "sr:match:10384252",
         *         "sr:match:10384256",
         *         "sr:match:10384386",
         *         "sr:match:10384390",
         *         "sr:match:10384396",
         *         "sr:match:10384398",
         *         "sr:match:10385656",
         *         "sr:match:10392656",
         *         "sr:match:10392658",
         *         "sr:match:10392662",
         *         "sr:match:10392668",
         *         "sr:match:10392670",
         *         "sr:match:10392672",
         *         "sr:match:10392674",
         *         "sr:match:10392680",
         *         "sr:match:10392686",
         *         "sr:match:10392688",
         *         "sr:match:10392692",
         *         "sr:match:10392694",
         *         "sr:match:10393306",
         *         "sr:match:10393308",
         *         "sr:match:10393310",
         *         "sr:match:10398492",
         *         "sr:match:10398494",
         *         "sr:match:10398500",
         *         "sr:match:10405742",
         *         "sr:match:10405744",
         *         "sr:match:10405822",
         *         "sr:match:10405866",
         *         "sr:match:10405868",
         *         "sr:match:10427654",
         *         "sr:match:10427656",
         *         "sr:match:10427700",
         *         "sr:match:10427702",
         *         "sr:match:10427708",
         *         "sr:match:10428406",
         *         "sr:match:10428408",
         *         "sr:match:10428410",
         *         "sr:match:10428412",
         *         "sr:match:10434960",
         *         "sr:match:10443610",
         *         "sr:match:10445268",
         *         "sr:match:10445270",
         *         "sr:match:10445972",
         *         "sr:match:10445974",
         *         "sr:match:10446008",
         *         "sr:match:10448786",
         *         "sr:match:10448946",
         *         "sr:match:10448948",
         *         "sr:match:10448972",
         *         "sr:match:10449076",
         *         "sr:match:10449084"
         *       ],
         *       "field": "name"
         *     }
         */
        "com.bz.league.sports.search.api.dto.I18nTranslateRequestDto": {
            /** @description URN ID列表 */
            urnIds: string[];
            /**
             * @description 要翻译的字段，默认是名字，也可以是其他字段（如：shortName）
             * @default name
             */
            field: string;
        };
        "com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.I18nTranslateResponse": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.I18nTranslateResponse"][];
        };
        /** @description 运动国际化多语言翻译请求参数 */
        "com.bz.league.sports.search.api.dto.I18nTranslateResponse": {
            /** @description urn */
            urn: string;
            /** @description 翻译的字段 */
            field: string;
            /** @description 翻译后的名称 */
            value: string;
        };
        "com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.sports.search.api.dto.VaixTopMatchesDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.VaixTopMatchesDto"][];
        };
        /** @description 体育ES数据 */
        "com.bz.league.sports.search.api.dto.VaixTopMatchesDto": {
            /**
             * @description 体育项目ID
             * @example sr:sport:1
             */
            sportId: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            sportName: string;
            /**
             * @description 体育项目中文名称
             * @example 足球
             */
            sportNameZh: string;
            /**
             * @description 体育项目Logo URL
             * @example https://example.com/sport_logo.png
             */
            sportLogoUrl: string;
            /**
             * @description 赛事类别ID
             * @example sr:category:29
             */
            categoryId: string;
            /**
             * @description 赛事类别名称
             * @example England
             */
            categoryName: string;
            /**
             * @description 赛事类别中文名称
             * @example 英格兰
             */
            categoryNameZh: string;
            /**
             * @description 赛事类别国家代码
             * @example ENG
             */
            categoryCountryCode: string;
            /**
             * @description 赛事类别Logo URL
             * @example https://example.com/category_logo.png
             */
            categoryLogoUrl: string;
            /**
             * @description 联赛/锦标赛ID
             * @example sr:tournament:17
             */
            tournamentId: string;
            /**
             * @description 联赛/锦标赛名称
             * @example Premier League
             */
            tournamentName: string;
            /**
             * @description 联赛/锦标赛中文名称
             * @example 英超联赛
             */
            tournamentNameZh: string;
            /**
             * @description 联赛/锦标赛简称
             * @example 英超
             */
            tournamentShortName: string;
            /**
             * @description 联赛/锦标赛缩写
             * @example EPL
             */
            tournamentAbbreviation: string;
            /**
             * @description 联赛/锦标赛Logo URL
             * @example https://example.com/tournament_logo.png
             */
            tournamentLogoUrl: string;
            /**
             * Format: int32
             * @description 联赛/锦标赛级别
             * @example 1
             */
            tournamentLevel: number;
            /**
             * Format: int32
             * @description 联赛/锦标赛性别（0:男, 1:女, 2:未知）
             * @example 0
             */
            tournamentGender: number;
            /**
             * Format: int32
             * @description 联赛/锦标赛类型 (1:联赛, 2:杯赛)
             * @example 1
             */
            tournamentType: number;
            /**
             * Format: int32
             * @description 排序值
             * @example 10
             */
            tournamentSort: number;
            /**
             * @description 是否为国家比赛
             * @example true
             */
            tournamentIsCountry: boolean;
            /**
             * @description 赛季ID
             * @example sr:season:93931
             */
            seasonId: string;
            /**
             * @description 赛季名称
             * @example Premier League 22/23
             */
            seasonName: string;
            /**
             * @description 赛季年份
             * @example 22/23
             */
            seasonYear: string;
            /**
             * @description 比赛ID或URN
             * @example sr:match:37939735
             */
            id: string;
            /**
             * @description 比赛名称
             * @example Arsenal vs Manchester United
             */
            name: string;
            /**
             * @description 主队ID
             * @example sr:competitor:42
             */
            homeId: string;
            /**
             * @description 主队名称
             * @example Arsenal
             */
            homeName: string;
            /**
             * @description 主队简称
             * @example ARS
             */
            homeShortName: string;
            /**
             * @description 主队缩写
             * @example ARS
             */
            homeAbbreviation: string;
            /**
             * @description 主队Logo URL
             * @example https://example.com/arsenal_logo.png
             */
            homeLogoUrl: string;
            /** @description 主队球衣 */
            homeJersey: string;
            /**
             * @description 主队国家代码
             * @example ENG
             */
            homeCountryCode: string;
            /**
             * @description 客队ID
             * @example sr:competitor:35
             */
            awayId: string;
            /**
             * @description 客队名称
             * @example Manchester United
             */
            awayName: string;
            /**
             * @description 客队简称
             * @example MU
             */
            awayShortName: string;
            /**
             * @description 客队缩写
             * @example MUN
             */
            awayAbbreviation: string;
            /**
             * @description 客队Logo URL
             * @example https://example.com/mu_logo.png
             */
            awayLogoUrl: string;
            /** @description 客队球衣 */
            awayJersey: string;
            /**
             * @description 客队国家代码
             * @example ENG
             */
            awayCountryCode: string;
            /**
             * @description 场馆ID
             * @example sr:venue:123
             */
            venueId: string;
            /**
             * @description 场馆名称
             * @example Emirates Stadium
             */
            venueName: string;
            /**
             * @description 裁判ID
             * @example sr:referee:456
             */
            refereeId: string;
            /**
             * @description 裁判名称
             * @example Anthony Taylor
             */
            refereeName: string;
            /**
             * @description 比赛类型
             * @example match
             */
            type: string;
            /**
             * @description 分组ID
             * @example sr:group:789
             */
            groupId: string;
            /**
             * @description 分组名称
             * @example Group A
             */
            groupName: string;
            /**
             * @description 阶段（例如：小组赛、淘汰赛）
             * @example Group Stage
             */
            phase: string;
            /**
             * @description 其他比赛ID
             * @example sr:match:99999
             */
            otherMatchId: string;
            /**
             * @description 联赛轮次
             * @example 21
             */
            tournamentRound: string;
            /**
             * Format: int64
             * @description 计划开始时间（Unix时间戳，毫秒）
             * @example 1674408600000
             */
            scheduledTime: number;
            /**
             * Format: int64
             * @description 计划结束时间（Unix时间戳，毫秒）
             * @example 1674415800000
             */
            scheduledEndTime: number;
            /**
             * Format: int32
             * @description 比赛状态
             */
            status: number;
            /** @description 比赛状态名称 */
            statusName: string;
            /**
             * Format: int32
             * @description 比赛状态
             */
            matchStatus: number;
            /** @description 比赛状态名称 */
            matchStatusName: string;
            sportEventStatus: components["schemas"]["com.bz.league.sports.search.api.dto.SportEventStatusDto"];
            marketBatchResponse: components["schemas"]["com.bz.odds.api.dto.MarketBatchResponse"];
            /**
             * @description 是否有雷达滚球赔率
             * @example true
             */
            hasRadarLiveOdds: boolean;
            /**
             * @description 是否有雷达赛前盘赔率
             * @example true
             */
            hasRadarPreMatchOdds: boolean;
            /** @description 直播流列表 */
            streamsList: components["schemas"]["com.bz.league.sports.search.api.dto.StreamsDto"][];
            /**
             * @description 推荐指数
             * @example 1
             */
            confidence: number;
            /** @description 是否下过单 */
            isPlaced: boolean;
            /** @description 关联的盘口列表 */
            markets: components["schemas"]["com.bz.league.sports.search.api.dto.VaixTopMatchesDto$TopMatchMarketResponse"][];
        };
        /** @description 关联的盘口列表 */
        "com.bz.league.sports.search.api.dto.VaixTopMatchesDto$TopMatchMarketResponse": {
            /**
             * 盘口ID
             * @description 盘口ID
             */
            marketId: string;
            /**
             * 玩法名称
             * @description 玩法名称
             */
            marketName: string;
            /**
             * 玩法显示名称
             * @description 玩法显示名称
             */
            displayName: string;
            marketTabType: string;
            colNameList: string[];
            /** Format: int32 */
            colSize: number;
            groupConfig: components["schemas"]["com.bz.odds.api.dto.GroupConfigDTO"];
            options: components["schemas"]["com.bz.odds.api.dto.OptionDTO"][];
            /**
             * 盘口投注项赔率列表
             * @description 盘口投注项赔率列表
             */
            marketSpecifierList: components["schemas"]["com.bz.odds.api.dto.MarketSpecifierDTO"][];
            /** Format: int32 */
            fire: number;
            popularBetName: string;
        };
        "com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.sports.search.api.dto.VaixSportsDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.VaixSportsDto"][];
        };
        "com.bz.league.sports.search.api.dto.VaixSportsDto": {
            /**
             * @description 体育项目ID
             * @example sr:sport:1
             */
            id: string;
            /**
             * @description 分数
             * @example 1
             */
            score: number;
            /**
             * @description 体育项目URN
             * @example sr:sport:1
             */
            name: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            nameZh: string;
            /**
             * Format: int64
             * @description 匹配的比赛数量
             * @example 5
             */
            matchCount: number;
        };
        "com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.sports.search.api.dto.VaixHotMatchesDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.VaixHotMatchesDto"][];
        };
        /** @description 按锦标赛分组的比赛聚合DTO，包含锦标赛、分类、运动及其关联的比赛列表 */
        "com.bz.league.sports.search.api.dto.VaixHotMatchesDto": {
            /**
             * @description 聚合ID
             * @example sr:tournament:12345
             */
            id: string;
            /**
             * @description 锦标赛的名称
             * @example Premier League
             */
            name: string;
            /**
             * @description 锦标赛的中文名称
             * @example 英超联赛
             */
            nameZh: string;
            /**
             * @description 锦标赛的简称
             * @example 英超
             */
            shortName: string;
            /**
             * @description 锦标赛缩写
             * @example EPL
             */
            abbreviation: string;
            /**
             * @description 锦标赛的logo URL
             * @example https://example.com/tournament_logo.png
             */
            logoUrl: string;
            /**
             * Format: int32
             * @description 联赛等级, -1：未初始化
             * @example 1
             */
            level: number;
            /**
             * Format: int32
             * @description 性别：0男，1女，2未知
             * @example 0
             */
            gender: number;
            /**
             * @description 关联的锦标赛当前赛季ID
             * @example sr:season:93931
             */
            currentSeasonId: string;
            /**
             * Format: int32
             * @description 联赛类型：-1 未初始化, 0-未知、1-联赛、2-杯赛、3-友谊赛
             * @example 1
             */
            type: number;
            /**
             * Format: int32
             * @description 排序值
             * @example 10
             */
            sort: number;
            /**
             * @description 是否国家队比赛
             * @example true
             */
            isCountry: boolean;
            /**
             * @description 关联的项目类别ID
             * @example sr:category:29
             */
            categoryId: string;
            /**
             * @description 关联的项目类别名称
             * @example England
             */
            categoryName: string;
            /**
             * @description 关联的项目类别中文名称
             * @example 英格兰
             */
            categoryNameZh: string;
            /**
             * @description 关联的项目类别Logo URL
             * @example https://example.com/category_logo.png
             */
            categoryLogoUrl: string;
            /**
             * @description 关联的项目类别国家/地区代码
             * @example ENG
             */
            categoryCountryCode: string;
            /**
             * @description 关联的体育项目ID
             * @example sr:sport:1
             */
            sportId: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            sportName: string;
            /**
             * @description 体育项目中文名称
             * @example 足球
             */
            sportNameZh: string;
            /**
             * @description 体育项目Logo URL
             * @example https://example.com/sport_logo.png
             */
            sportLogoUrl: string;
            /**
             * Format: int64
             * @description 关联的比赛数量
             * @example 10
             */
            matchCount: number;
            /** @description 关联的比赛列表 */
            matches: components["schemas"]["com.bz.league.sports.search.api.dto.VaixHotMatchesDto$VaixMatchDto"][];
            /**
             * @description 推荐指数
             * @example 1
             */
            confidence: number;
        };
        /** @description 赛季比赛文档DTO，包含赛季信息和比赛详细数据 */
        "com.bz.league.sports.search.api.dto.VaixHotMatchesDto$SeasonMatchDocumentInnerDto": {
            /**
             * @description 赛季ID
             * @example sr:season:93931
             */
            seasonId: string;
            /**
             * @description 推荐指数
             * @example 1
             */
            confidence: number;
            /**
             * @description 赛季名称
             * @example Premier League 22/23
             */
            seasonName: string;
            /**
             * @description 赛季年份
             * @example 22/23
             */
            seasonYear: string;
            /**
             * @description 比赛ID或URN
             * @example sr:match:37939735
             */
            id: string;
            /**
             * @description 比赛名称
             * @example Arsenal vs Manchester United
             */
            name: string;
            /**
             * @description 主队ID
             * @example sr:competitor:42
             */
            homeId: string;
            /**
             * @description 主队名称
             * @example Arsenal
             */
            homeName: string;
            /**
             * @description 主队简称
             * @example ARS
             */
            homeShortName: string;
            /**
             * @description 主队Logo URL
             * @example https://example.com/arsenal_logo.png
             */
            homeLogoUrl: string;
            /** @description 主队球衣 */
            homeJersey: string;
            /**
             * @description 主队国家/地区代码
             * @example ENG
             */
            homeCountryCode: string;
            /**
             * @description 客队ID
             * @example sr:competitor:35
             */
            awayId: string;
            /**
             * @description 客队名称
             * @example Manchester United
             */
            awayName: string;
            /**
             * @description 客队简称
             * @example MU
             */
            awayShortName: string;
            /**
             * @description 客队Logo URL
             * @example https://example.com/mu_logo.png
             */
            awayLogoUrl: string;
            /** @description 客队球衣 */
            awayJersey: string;
            /**
             * @description 客队国家/地区代码
             * @example ENG
             */
            awayCountryCode: string;
            /**
             * @description 场馆ID
             * @example sr:venue:123
             */
            venueId: string;
            /**
             * @description 场馆名称
             * @example Emirates Stadium
             */
            venueName: string;
            /**
             * @description 裁判ID
             * @example sr:referee:456
             */
            refereeId: string;
            /**
             * @description 裁判名称
             * @example Anthony Taylor
             */
            refereeName: string;
            /**
             * @description 比赛类型
             * @example match
             */
            type: string;
            /**
             * @description 分组ID
             * @example sr:group:789
             */
            groupId: string;
            /**
             * @description 分组名称
             * @example Group A
             */
            groupName: string;
            /**
             * @description 阶段（例如：小组赛、淘汰赛）
             * @example Group Stage
             */
            phase: string;
            /**
             * @description 其他比赛ID
             * @example sr:match:99999
             */
            otherMatchId: string;
            /**
             * @description 联赛轮次
             * @example 21
             */
            tournamentRound: string;
            /**
             * Format: int64
             * @description 计划开始时间（Unix时间戳，毫秒）
             * @example 1674408600000
             */
            scheduledTime: number;
            /**
             * Format: int64
             * @description 计划结束时间（Unix时间戳，毫秒）
             * @example 1674415800000
             */
            scheduledEndTime: number;
            /**
             * Format: int32
             * @description 比赛状态
             */
            status: number;
            /** @description 比赛状态名称 */
            statusName: string;
            /**
             * Format: int32
             * @description 比赛状态
             */
            matchStatus: number;
            /** @description 比赛状态名称 */
            matchStatusName: string;
            sportEventStatus: components["schemas"]["com.bz.league.sports.search.api.dto.SportEventStatusDto"];
            /**
             * @description 是否有雷达滚球赔率
             * @example true
             */
            hasRadarLiveOdds: boolean;
            /**
             * @description 是否有雷达赛前盘赔率
             * @example true
             */
            hasRadarPreMatchOdds: boolean;
            marketBatchResponse: components["schemas"]["com.bz.odds.api.dto.MarketBatchResponse"];
            /** @description 直播流列表 */
            streamsList: components["schemas"]["com.bz.league.sports.search.api.dto.StreamsDto"][];
        };
        "com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.sports.recommend.api.dto.response.VaixRecommendBetDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.recommend.api.dto.response.VaixRecommendBetDto"][];
        };
        "com.bz.league.sports.recommend.api.dto.response.VaixBetMatchInfo": {
            /**
             * @description 体育项目ID
             * @example sr:sport:1
             */
            sportId: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            sportName: string;
            /**
             * @description 体育项目Logo URL
             * @example https://example.com/sport_logo.png
             */
            sportLogoUrl: string;
            /**
             * @description 赛事类别ID
             * @example sr:category:29
             */
            categoryId: string;
            /**
             * @description 赛事类别名称
             * @example England
             */
            categoryName: string;
            /**
             * @description 赛事类别国家代码
             * @example ENG
             */
            categoryCountryCode: string;
            /**
             * @description 赛事类别Logo URL
             * @example https://example.com/category_logo.png
             */
            categoryLogoUrl: string;
            /**
             * @description 联赛/锦标赛ID
             * @example sr:tournament:17
             */
            tournamentId: string;
            /**
             * @description 联赛/锦标赛名称
             * @example Premier League
             */
            tournamentName: string;
            /**
             * @description 联赛/锦标赛简称
             * @example 英超
             */
            tournamentShortName: string;
            /**
             * @description 联赛/锦标赛Logo URL
             * @example https://example.com/tournament_logo.png
             */
            tournamentLogoUrl: string;
            /**
             * Format: int32
             * @description 联赛/锦标赛级别
             * @example 1
             */
            tournamentLevel: number;
            /**
             * Format: int32
             * @description 联赛/锦标赛性别（0:男, 1:女, 2:未知）
             * @example 0
             */
            tournamentGender: number;
            /**
             * Format: int32
             * @description 联赛/锦标赛类型 (1:联赛, 2:杯赛)
             * @example 1
             */
            tournamentType: number;
            /**
             * Format: int32
             * @description 排序值
             * @example 10
             */
            tournamentSort: number;
            /**
             * @description 是否为国家比赛
             * @example true
             */
            tournamentIsCountry: boolean;
            /**
             * @description 赛季ID
             * @example sr:season:93931
             */
            seasonId: string;
            /**
             * @description 赛季名称
             * @example Premier League 22/23
             */
            seasonName: string;
            /**
             * @description 赛季年份
             * @example 22/23
             */
            seasonYear: string;
            /**
             * @description 比赛ID或URN
             * @example sr:match:37939735
             */
            id: string;
            /**
             * @description 比赛名称
             * @example Arsenal vs Manchester United
             */
            name: string;
            /**
             * @description 主队ID
             * @example sr:competitor:42
             */
            homeId: string;
            /**
             * @description 主队名称
             * @example Arsenal
             */
            homeName: string;
            /**
             * @description 主队简称
             * @example ARS
             */
            homeShortName: string;
            /**
             * @description 主队Logo URL
             * @example https://example.com/arsenal_logo.png
             */
            homeLogoUrl: string;
            /** @description 主队球衣 */
            homeJersey: string;
            /**
             * @description 主队国家代码
             * @example ENG
             */
            homeCountryCode: string;
            /**
             * @description 客队ID
             * @example sr:competitor:35
             */
            awayId: string;
            /**
             * @description 客队名称
             * @example Manchester United
             */
            awayName: string;
            /**
             * @description 客队简称
             * @example MU
             */
            awayShortName: string;
            /**
             * @description 客队Logo URL
             * @example https://example.com/mu_logo.png
             */
            awayLogoUrl: string;
            /** @description 客队球衣 */
            awayJersey: string;
            /**
             * @description 客队国家代码
             * @example ENG
             */
            awayCountryCode: string;
            /**
             * @description 场馆ID
             * @example sr:venue:123
             */
            venueId: string;
            /**
             * @description 场馆名称
             * @example Emirates Stadium
             */
            venueName: string;
            /**
             * @description 裁判ID
             * @example sr:referee:456
             */
            refereeId: string;
            /**
             * @description 裁判名称
             * @example Anthony Taylor
             */
            refereeName: string;
            /**
             * @description 比赛类型
             * @example match
             */
            type: string;
            /**
             * @description 分组ID
             * @example sr:group:789
             */
            groupId: string;
            /**
             * @description 分组名称
             * @example Group A
             */
            groupName: string;
            /**
             * @description 阶段（例如：小组赛、淘汰赛）
             * @example Group Stage
             */
            phase: string;
            /**
             * @description 联赛轮次
             * @example 21
             */
            tournamentRound: string;
            /**
             * Format: int64
             * @description 计划开始时间（Unix时间戳，毫秒）
             * @example 1674408600000
             */
            scheduledTime: number;
            /**
             * Format: int64
             * @description 计划结束时间（Unix时间戳，毫秒）
             * @example 1674415800000
             */
            scheduledEndTime: number;
            /**
             * Format: int32
             * @description 比赛状态, 0: not_started, 1: live, 2: suspended, 3: ended, 4: closed
             */
            status: number;
            /** @description 比赛状态名称 */
            statusName: string;
            /**
             * Format: int32
             * @description 比赛状态
             */
            matchStatus: number;
            /** @description 比赛状态名称 */
            matchStatusName: string;
            /**
             * @description 是否有雷达滚球赔率
             * @example true
             */
            hasRadarLiveOdds: boolean;
            /**
             * @description 是否有雷达赛前盘赔率
             * @example true
             */
            hasRadarPreMatchOdds: boolean;
        };
        /** @description 投注项信息 */
        "com.bz.league.sports.recommend.api.dto.response.VaixBetOutcomeItemDto": {
            matchInfo: components["schemas"]["com.bz.league.sports.recommend.api.dto.response.VaixBetMatchInfo"];
            /** @description odds 唯一编码 */
            code: string;
            /** @description 比赛 id */
            matchId: string;
            /** @description 市场id */
            marketId: string;
            specifiers: string;
            outcomeId: string;
            marketName: string;
            outcomeName: string;
            /** @description outcome 英文名称，原始字段 */
            outcomeNameEn: string;
            colName: string;
            /** @description 赔率 */
            odds: number;
            /**
             * Format: int32
             * @description 投注数量
             */
            count: number;
            /**
             * Format: int32
             * @description 是否有效，1 有效，0 无效
             */
            active: number;
            selectionId: string;
        };
        "com.bz.league.sports.recommend.api.dto.response.VaixRecommendBetDto": {
            /** @description 类型, combo or custom_bet */
            type: string;
            /** @description 子类型, same_league:同运动，同联赛，不同比赛;cross_league:同运动，不同联赛，不同比赛;custom_bet:场景3:足/篮/网：支持同场比赛的custom bet high_risk:场景4：为寻求高回报的用户推荐“博冷”串关 */
            subType: string;
            /**
             * Format: int64
             * @description 跟单人
             */
            followers: number;
            /** @description 是否下过单 */
            isPlaced: boolean;
            /** @description 推荐单唯一标识， */
            betId: string;
            /** @description 初始总赔率 */
            originalTotalOdds: number;
            /** @description 最新总赔率 */
            currentTotalOdds: number;
            /**
             * Format: double
             * @description 分数，作为排序依据
             */
            score: number;
            /**
             * Format: double
             * @description 置信度
             */
            confidence: number;
            /** @description 投注项信息 */
            betItemList: components["schemas"]["com.bz.league.sports.recommend.api.dto.response.VaixBetOutcomeItemDto"][];
            /**
             * @description 体育项目ID
             * @example sr:sport:1
             */
            sportId: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            sportName: string;
            /**
             * @description 体育项目Logo URL
             * @example https://example.com/sport_logo.png
             */
            sportLogoUrl: string;
            /**
             * @description 赛事类别ID
             * @example sr:category:29
             */
            categoryId: string;
            /**
             * @description 赛事类别名称
             * @example England
             */
            categoryName: string;
            /**
             * @description 赛事类别国家代码
             * @example ENG
             */
            categoryCountryCode: string;
            /**
             * @description 赛事类别Logo URL
             * @example https://example.com/category_logo.png
             */
            categoryLogoUrl: string;
            /**
             * @description 联赛/锦标赛ID
             * @example sr:tournament:17
             */
            tournamentId: string;
            /**
             * @description 联赛/锦标赛名称
             * @example Premier League
             */
            tournamentName: string;
            /**
             * @description 联赛/锦标赛Logo URL
             * @example https://example.com/tournament_logo.png
             */
            tournamentLogoUrl: string;
        };
        "com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.SportTreeDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.SportTreeDto"][];
        };
        /** @description 体育项目树形结构DTO，包含体育项目、类别和赛事信息 */
        "com.bz.league.sports.search.api.dto.SportTreeDto": {
            /**
             * @description 关联的体育项目ID
             * @example sr:sport:1
             */
            id: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            name: string;
            /**
             * @description 体育项目中文名称
             * @example 足球
             */
            nameZh: string;
            /**
             * @description 体育项目Logo URL
             * @example https://example.com/sport_logo.png
             */
            logoUrl: string;
            /**
             * Format: int32
             * @description 体育项目logo地址
             */
            sort: number;
            /**
             * Format: int32
             * @description top排序值
             * @example 10
             */
            topSort: number;
            /**
             * Format: int32
             * @description 1：传统体育，2：电子竞技；后续如果还要再拆分，3：all racing，4：虚拟体育/仿真现实
             * @example 1
             */
            mode: number;
            /** @description 项目类别列表 */
            categories: components["schemas"]["com.bz.league.sports.search.api.dto.SportTreeDto$CategoryInner"][];
            /**
             * Format: int64
             * @description 关联的比赛数量
             * @example 100
             */
            matchCount: number;
            /**
             * Format: int64
             * @description 关联的冠军盘数量
             * @example 100
             */
            outrightCount: number;
        };
        /** @description 体育项目类别DTO */
        "com.bz.league.sports.search.api.dto.SportTreeDto$CategoryInner": {
            /**
             * @description 关联的项目类别ID
             * @example sr:category:29
             */
            id: string;
            /**
             * @description 关联的项目类别名称
             * @example England
             */
            name: string;
            /**
             * @description 关联的项目类别中文名称
             * @example 英格兰
             */
            nameZh: string;
            /**
             * @description 关联的项目类别Logo URL
             * @example https://example.com/category_logo.png
             */
            logoUrl: string;
            /**
             * @description 关联的项目类别国家/地区代码
             * @example ENG
             */
            countryCode: string;
            /** @description 锦标赛列表 */
            tournaments: components["schemas"]["com.bz.league.sports.search.api.dto.SportTreeDto$TournamentInner"][];
            /**
             * Format: int64
             * @description 关联的比赛数量
             * @example 10
             */
            matchCount: number;
            /**
             * Format: int64
             * @description 关联的冠军盘数量
             * @example 100
             */
            outrightCount: number;
        };
        /** @description 锦标赛DTO */
        "com.bz.league.sports.search.api.dto.SportTreeDto$TournamentInner": {
            /**
             * @description 聚合ID
             * @example sr:tournament:12345
             */
            id: string;
            /**
             * @description 锦标赛的名称
             * @example Premier League
             */
            name: string;
            /**
             * @description 锦标赛的中文名称
             * @example 英超联赛
             */
            nameZh: string;
            /**
             * @description 锦标赛的简称
             * @example 英超
             */
            shortName: string;
            /**
             * @description 锦标赛缩写
             * @example EPL
             */
            abbreviation: string;
            /**
             * @description 锦标赛的logo URL
             * @example https://example.com/tournament_logo.png
             */
            logoUrl: string;
            /**
             * Format: int32
             * @description 联赛等级, -1：未初始化
             * @example 1
             */
            level: number;
            /**
             * Format: int32
             * @description 性别：0男，1女，2未知
             * @example 0
             */
            gender: number;
            /**
             * @description 关联的锦标赛当前赛季ID
             * @example sr:season:93931
             */
            currentSeasonId: string;
            /**
             * Format: int32
             * @description 联赛类型：-1 未初始化, 0-未知、1-联赛、2-杯赛、3-友谊赛
             * @example 1
             */
            type: number;
            /**
             * Format: int32
             * @description 排序值
             * @example 10
             */
            sort: number;
            /**
             * Format: int64
             * @description 关联的比赛数量
             * @example 10
             */
            matchCount: number;
            /**
             * Format: int64
             * @description 关联的冠军盘数量
             * @example 100
             */
            outrightCount: number;
        };
        "com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.SportRecommendDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.SportRecommendDto"][];
        };
        /** @description 运动推荐DTO，包含赛事信息和匹配的比赛数量 */
        "com.bz.league.sports.search.api.dto.SportRecommendDto": {
            id: string;
            /**
             * @description 体育项目URN
             * @example sr:sport:1
             */
            name: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            nameZh: string;
            /**
             * @description 体育项目中文名称
             * @example 足球
             */
            logoUrl: string;
            /**
             * Format: int32
             * @description 体育项目logo地址
             */
            sort: number;
            /**
             * Format: int64
             * @description 匹配的比赛数量
             * @example 5
             */
            matchCount: number;
        };
        "com.bz.common.dto.MultiResponseCom.bz.league.sports.search.server.infra.algo.resp.VaixSportsResponse": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.server.infra.algo.resp.VaixSportsResponse"][];
        };
        "com.bz.league.sports.search.server.infra.algo.resp.VaixSportsResponse": {
            /**
             * @description 体育项目ID
             * @example sr:sport:1
             */
            id: string;
            /**
             * @description 分数
             * @example 1
             */
            score: string;
            /**
             * @description 体育项目URN
             * @example sr:sport:1
             */
            name: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            nameZh: string;
            /**
             * Format: int64
             * @description 匹配的比赛数量
             * @example 5
             */
            matchCount: number;
            /**
             * @description 国家ID
             * @example 1
             */
            countryId: string;
            /**
             * @description 国家名称
             * @example England
             */
            country: string;
            /**
             * @description 国家图标
             * @example https://cdn.sportradar.com/images/sport/countries/32/en/1.png
             */
            countryUrl: string;
            /**
             * @description 联赛ID
             * @example 1
             */
            leagueId: string;
            /**
             * @description 联赛名称
             * @example Premier League
             */
            league: string;
            /**
             * @description 联赛图标
             * @example https://cdn.sportradar.com/images/sport/leagues/32/en/1.png
             */
            leagueLogoUrl: string;
        };
        "com.bz.common.dto.MultiResponseCom.bz.league.sports.recommend.api.dto.response.VaixRecommendBetDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.recommend.api.dto.response.VaixRecommendBetDto"][];
        };
        "com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.OutRightAggMatchHitDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.OutRightAggMatchHitDto"][];
        };
        /** @description 按分类分组的冠军盘聚合DTO，包含分类、运动及其关联的冠军盘列表 */
        "com.bz.league.sports.search.api.dto.OutRightAggMatchHitDto": {
            /**
             * Format: int32
             * @description 排序值
             * @example 10
             */
            sort: number;
            /**
             * @description 关联的项目类别ID
             * @example sr:category:29
             */
            categoryId: string;
            /**
             * @description 关联的项目类别名称
             * @example England
             */
            categoryName: string;
            /**
             * @description 项目类别图标
             * @example http//xxxxxxx
             */
            categoryUrl: string;
            /** @description 关联的盘口列表 */
            outRights: components["schemas"]["com.bz.league.sports.search.api.dto.OutRightAggMatchHitDto$OutRightDocumentInnerDto"][];
        };
        /** @description 赛季比赛文档DTO，包含赛季信息和比赛详细数据 */
        "com.bz.league.sports.search.api.dto.OutRightAggMatchHitDto$OutRightDocumentInnerDto": {
            /**
             * @description 冠军盘id
             * @example sr:stage:1234
             */
            id: string;
            /**
             * @description 冠军盘名称
             * @example F1 2025
             */
            name: string;
            /**
             * Format: int32
             * @description 冠军盘口数量
             * @example 10
             */
            outrightCount: number;
            /**
             * Format: int32
             * @description 排序值
             * @example 10
             */
            sort: number;
            /**
             * @description 联赛id
             * @example sr:stage:1234
             */
            tournamentId: string;
            /**
             * @description 联赛名称
             * @example F1 2025
             */
            tournamentName: string;
            /**
             * @description 项目联赛图标
             * @example http//xxxxxxx
             */
            tournamentUrl: string;
        };
        "com.bz.common.dto.SingleResponseCom.bz.league.sports.search.api.dto.SeasonMatchDocumentDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.SeasonMatchDocumentDto"];
        };
        "com.bz.common.dto.SingleResponseCom.bz.league.sports.search.api.dto.MatchPlayersDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.MatchPlayersDto"];
        };
        /** @description 比赛双方球员列表 */
        "com.bz.league.sports.search.api.dto.MatchPlayersDto": {
            /**
             * @description 比赛ID
             * @example sr:match:37939735
             */
            matchId: string;
            /** @description 主队球员列表 */
            homePlayers: components["schemas"]["com.bz.league.sports.search.api.dto.PlayerDto"][];
            /** @description 客队球员列表 */
            awayPlayers: components["schemas"]["com.bz.league.sports.search.api.dto.PlayerDto"][];
        };
        "com.bz.common.dto.SingleResponseCom.bz.league.sports.search.api.dto.CheckMatchDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.CheckMatchDto"];
        };
        /** @description 判断是否存在比赛和冠军盘 */
        "com.bz.league.sports.search.api.dto.CheckMatchDto": {
            hasLiveOrUpcomingMatch: boolean;
            hasOutright: boolean;
        };
        "com.bz.common.dto.MultiResponseCom.bz.league.sports.search.server.domain.repository.SportAlgoSearchResponse": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.server.domain.repository.SportAlgoSearchResponse"][];
        };
        "com.bz.league.sports.search.server.domain.repository.SportAlgoSearchResponse": {
            /** @description 运动类型ID */
            sportId: string;
            /** @description 运动类型名称 */
            sportName: string;
            /** @description 运动类型名称图片地址 */
            sportLogoUrl: string;
            /**
             * Format: int64
             * @description 比赛数量
             */
            matchesCount: number;
            /** @description 比赛列表 */
            leagueList: components["schemas"]["com.bz.league.sports.search.server.infra.algo.resp.VaixHotMatchesResponse"][];
        };
        /** @description 体育ES数据 */
        "com.bz.league.sports.search.server.infra.algo.resp.VaixHotMatchesResponse": {
            /**
             * @description 聚合ID
             * @example sr:tournament:12345
             */
            id: string;
            /**
             * @description 分数
             * @example 1
             */
            score: string;
            /**
             * @description 锦标赛的名称
             * @example Premier League
             */
            name: string;
            /**
             * @description 锦标赛的中文名称
             * @example 英超联赛
             */
            nameZh: string;
            /**
             * @description 锦标赛的简称
             * @example 英超
             */
            shortName: string;
            /**
             * @description 锦标赛的logo URL
             * @example https://example.com/tournament_logo.png
             */
            logoUrl: string;
            /**
             * Format: int32
             * @description 联赛等级, -1：未初始化
             * @example 1
             */
            level: number;
            /**
             * Format: int32
             * @description 性别：0男，1女，2未知
             * @example 0
             */
            gender: number;
            /**
             * @description 关联的锦标赛当前赛季ID
             * @example sr:season:93931
             */
            currentSeasonId: string;
            /**
             * Format: int32
             * @description 联赛类型：-1 未初始化, 0-未知、1-联赛、2-杯赛、3-友谊赛
             * @example 1
             */
            type: number;
            /**
             * Format: int32
             * @description 排序值
             * @example 10
             */
            sort: number;
            /**
             * @description 是否国家队比赛
             * @example true
             */
            isCountry: boolean;
            /**
             * @description 关联的项目类别ID
             * @example sr:category:29
             */
            categoryId: string;
            /**
             * @description 关联的项目类别名称
             * @example England
             */
            categoryName: string;
            /**
             * @description 关联的项目类别中文名称
             * @example 英格兰
             */
            categoryNameZh: string;
            /**
             * @description 关联的项目类别Logo URL
             * @example https://example.com/category_logo.png
             */
            categoryLogoUrl: string;
            /**
             * @description 关联的项目类别国家/地区代码
             * @example ENG
             */
            categoryCountryCode: string;
            /**
             * @description 关联的体育项目ID
             * @example sr:sport:1
             */
            sportId: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            sportName: string;
            /**
             * @description 体育项目中文名称
             * @example 足球
             */
            sportNameZh: string;
            /**
             * @description 体育项目Logo URL
             * @example https://example.com/sport_logo.png
             */
            sportLogoUrl: string;
            /**
             * Format: int64
             * @description 关联的比赛数量
             * @example 10
             */
            matchCount: number;
            /** @description 关联的比赛列表 */
            matches: components["schemas"]["com.bz.league.sports.search.server.infra.algo.resp.VaixHotMatchesResponse$SeasonMatchDocumentInnerDto"][];
        };
        /** @description 赛季比赛文档DTO，包含赛季信息和比赛详细数据 */
        "com.bz.league.sports.search.server.infra.algo.resp.VaixHotMatchesResponse$SeasonMatchDocumentInnerDto": {
            /**
             * @description 赛季ID
             * @example sr:season:93931
             */
            seasonId: string;
            /**
             * @description 分数
             * @example 1
             */
            score: string;
            /**
             * @description 赛季名称
             * @example Premier League 22/23
             */
            seasonName: string;
            /**
             * @description 赛季年份
             * @example 22/23
             */
            seasonYear: string;
            /**
             * @description 比赛ID或URN
             * @example sr:match:37939735
             */
            id: string;
            /**
             * @description 比赛名称
             * @example Arsenal vs Manchester United
             */
            name: string;
            /**
             * @description 主队ID
             * @example sr:competitor:42
             */
            homeId: string;
            /**
             * @description 主队名称
             * @example Arsenal
             */
            homeName: string;
            /**
             * @description 主队简称
             * @example ARS
             */
            homeShortName: string;
            /**
             * @description 主队Logo URL
             * @example https://example.com/arsenal_logo.png
             */
            homeLogoUrl: string;
            /** @description 主队球衣 */
            homeJersey: string;
            /**
             * @description 主队国家/地区代码
             * @example ENG
             */
            homeCountryCode: string;
            /**
             * @description 客队ID
             * @example sr:competitor:35
             */
            awayId: string;
            /**
             * @description 客队名称
             * @example Manchester United
             */
            awayName: string;
            /**
             * @description 客队简称
             * @example MU
             */
            awayShortName: string;
            /**
             * @description 客队Logo URL
             * @example https://example.com/mu_logo.png
             */
            awayLogoUrl: string;
            /** @description 客队球衣 */
            awayJersey: string;
            /**
             * @description 客队国家/地区代码
             * @example ENG
             */
            awayCountryCode: string;
            /**
             * @description 场馆ID
             * @example sr:venue:123
             */
            venueId: string;
            /**
             * @description 场馆名称
             * @example Emirates Stadium
             */
            venueName: string;
            /**
             * @description 裁判ID
             * @example sr:referee:456
             */
            refereeId: string;
            /**
             * @description 裁判名称
             * @example Anthony Taylor
             */
            refereeName: string;
            /**
             * @description 比赛类型
             * @example match
             */
            type: string;
            /**
             * @description 分组ID
             * @example sr:group:789
             */
            groupId: string;
            /**
             * @description 分组名称
             * @example Group A
             */
            groupName: string;
            /**
             * @description 阶段（例如：小组赛、淘汰赛）
             * @example Group Stage
             */
            phase: string;
            /**
             * @description 其他比赛ID
             * @example sr:match:99999
             */
            otherMatchId: string;
            /**
             * @description 联赛轮次
             * @example 21
             */
            tournamentRound: string;
            /**
             * Format: int64
             * @description 计划开始时间（Unix时间戳，毫秒）
             * @example 1674408600000
             */
            scheduledTime: number;
            /**
             * Format: int64
             * @description 计划结束时间（Unix时间戳，毫秒）
             * @example 1674415800000
             */
            scheduledEndTime: number;
            /**
             * Format: int32
             * @description 比赛状态
             */
            status: number;
            /** @description 比赛状态名称 */
            statusName: string;
            /**
             * Format: int32
             * @description 比赛状态
             */
            matchStatus: number;
            /** @description 比赛状态名称 */
            matchStatusName: string;
            sportEventStatus: components["schemas"]["com.bz.league.sports.search.api.dto.SportEventStatusDto"];
            /**
             * @description 是否有雷达滚球赔率
             * @example true
             */
            hasRadarLiveOdds: boolean;
            /**
             * @description 是否有雷达赛前盘赔率
             * @example true
             */
            hasRadarPreMatchOdds: boolean;
            marketBatchResponse: components["schemas"]["com.bz.odds.api.dto.MarketBatchResponse"];
        };
        "com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.sports.search.api.dto.VaixLeagueDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.VaixLeagueDto"][];
        };
        "com.bz.league.sports.search.api.dto.VaixLeagueDto": {
            id: string;
            score: number;
            name: string;
            sportId: string;
            sportName: string;
            categoryId: string;
            categoryName: string;
            shortName: string;
            logoUrl: string;
            currentSeasonId: string;
            sportScore: number;
        };
        "com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.SportAggTournamentHitDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.SportAggTournamentHitDto"][];
        };
        /** @description 按运动聚合的DTO，包含运动信息及其下属的锦标赛列表 */
        "com.bz.league.sports.search.api.dto.SportAggTournamentHitDto": {
            /**
             * @description 体育项目ID
             * @example sr:sport:1
             */
            id: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            name: string;
            /**
             * @description 体育项目中文名称
             * @example 足球
             */
            nameZh: string;
            /**
             * @description 体育项目Logo URL
             * @example https://example.com/sport_logo.png
             */
            logoUrl: string;
            /**
             * Format: int64
             * @description 该运动下的总比赛数量
             * @example 25
             */
            matchCount: number;
            /** @description 该运动下的锦标赛列表 */
            tournaments: components["schemas"]["com.bz.league.sports.search.api.dto.TournamentAggMatchHitDto"][];
        };
        /** @description 比赛搜索请求 */
        "com.bz.league.sports.search.api.request.MatchSearchRequest": {
            /**
             * Format: int32
             * @description odds显示模式，0: standard（默认）, 1: 3-way, 2: professional
             * @example 1
             */
            marketMode?: number;
            /**
             * Format: int32
             * @description 联赛显示模式，1: By league, 0: By time
             * @example 1
             */
            leagueMode?: number;
            /**
             * @description 运动项目ID
             * @example sr:sport:1
             */
            sportId?: string;
            /**
             * @description 分类ID
             * @example sr:category:1
             */
            categoryId?: string;
            /**
             * @description 联赛ID
             * @example sr:tournament:1
             */
            tournamentId?: string;
            /**
             * @description 比赛状态列表,upcoming: 0, live: 1
             * @example 0,1
             */
            statusList: string[];
            /**
             * Format: int64
             * @description 计划时间 (Unix timestamp in milliseconds)
             * @example 1678886400000
             */
            scheduledTime?: number;
            /**
             * Format: int32
             * @description 条数限制，必须大于0，非必填
             * @example 0
             */
            pageSize?: number;
            /**
             * @description 搜索关键词
             * @example liverpool
             */
            keyword?: string;
            /**
             * @description 联赛ID列表
             * @example sr:tournament:1,sr:tournament:2
             */
            tournamentIds?: string[];
        };
        /** @description 赛季比赛文档DTO，包含赛季信息和比赛详细数据 */
        "com.bz.league.sports.search.api.dto.VaixHotMatchesDto$VaixMatchDto": {
            /**
             * @description 赛季ID
             * @example sr:season:93931
             */
            seasonId: string;
            /**
             * @description 赛季名称
             * @example Premier League 22/23
             */
            seasonName: string;
            /**
             * @description 赛季年份
             * @example 22/23
             */
            seasonYear: string;
            /**
             * @description 比赛ID或URN
             * @example sr:match:37939735
             */
            id: string;
            /**
             * @description 体育项目ID
             * @example sr:sport:1
             */
            sportId: string;
            /**
             * @description 比赛名称
             * @example Arsenal vs Manchester United
             */
            name: string;
            /**
             * @description 主队ID
             * @example sr:competitor:42
             */
            homeId: string;
            /**
             * @description 主队名称
             * @example Arsenal
             */
            homeName: string;
            /**
             * @description 主队简称
             * @example ARS
             */
            homeShortName: string;
            /**
             * @description 主队缩写
             * @example ARS
             */
            homeAbbreviation: string;
            /**
             * @description 主队Logo URL
             * @example https://example.com/arsenal_logo.png
             */
            homeLogoUrl: string;
            /** @description 主队球衣 */
            homeJersey: string;
            /**
             * @description 主队国家/地区代码
             * @example ENG
             */
            homeCountryCode: string;
            /**
             * @description 客队ID
             * @example sr:competitor:35
             */
            awayId: string;
            /**
             * @description 客队名称
             * @example Manchester United
             */
            awayName: string;
            /**
             * @description 客队简称
             * @example MU
             */
            awayShortName: string;
            /**
             * @description 客队缩写
             * @example MUN
             */
            awayAbbreviation: string;
            /**
             * @description 客队Logo URL
             * @example https://example.com/mu_logo.png
             */
            awayLogoUrl: string;
            /** @description 客队球衣 */
            awayJersey: string;
            /**
             * @description 客队国家/地区代码
             * @example ENG
             */
            awayCountryCode: string;
            /**
             * @description 场馆ID
             * @example sr:venue:123
             */
            venueId: string;
            /**
             * @description 场馆名称
             * @example Emirates Stadium
             */
            venueName: string;
            /**
             * @description 裁判ID
             * @example sr:referee:456
             */
            refereeId: string;
            /**
             * @description 裁判名称
             * @example Anthony Taylor
             */
            refereeName: string;
            /**
             * @description 比赛类型
             * @example match
             */
            type: string;
            /**
             * @description 分组ID
             * @example sr:group:789
             */
            groupId: string;
            /**
             * @description 分组名称
             * @example Group A
             */
            groupName: string;
            /**
             * @description 阶段（例如：小组赛、淘汰赛）
             * @example Group Stage
             */
            phase: string;
            /**
             * @description 其他比赛ID
             * @example sr:match:99999
             */
            otherMatchId: string;
            /**
             * @description 联赛轮次
             * @example 21
             */
            tournamentRound: string;
            /**
             * Format: int64
             * @description 计划开始时间（Unix时间戳，毫秒）
             * @example 1674408600000
             */
            scheduledTime: number;
            /**
             * Format: int64
             * @description 计划结束时间（Unix时间戳，毫秒）
             * @example 1674415800000
             */
            scheduledEndTime: number;
            /**
             * Format: int32
             * @description 比赛状态
             */
            status: number;
            /** @description 比赛状态名称 */
            statusName: string;
            /**
             * Format: int32
             * @description 比赛状态
             */
            matchStatus: number;
            /** @description 比赛状态名称 */
            matchStatusName: string;
            sportEventStatus: components["schemas"]["com.bz.league.sports.search.api.dto.SportEventStatusDto"];
            /**
             * @description 是否有雷达滚球赔率
             * @example true
             */
            hasRadarLiveOdds: boolean;
            /**
             * @description 是否有雷达赛前盘赔率
             * @example true
             */
            hasRadarPreMatchOdds: boolean;
            marketBatchResponse: components["schemas"]["com.bz.odds.api.dto.MarketBatchResponse"];
            /** @description 直播流列表 */
            streamsList: components["schemas"]["com.bz.league.sports.search.api.dto.StreamsDto"][];
            /**
             * @description 推荐指数
             * @example 1
             */
            confidence: number;
        };
        /** @description Season match document DTO, containing season information and match detailed data */
        "com.bz.league.sports.search.api.dto.BaseTournamentAggMatchHitDto$SeasonMatchDocumentInnerDto": {
            /**
             * @description Season ID
             * @example sr:season:93931
             */
            seasonId: string;
            /**
             * @description Season name
             * @example Premier League 22/23
             */
            seasonName: string;
            /**
             * @description Season year
             * @example 22/23
             */
            seasonYear: string;
            /**
             * @description Match ID or URN
             * @example sr:match:37939735
             */
            id: string;
            /**
             * @description Sport ID
             * @example sr:sport:1
             */
            sportId: string;
            /**
             * @description Match name
             * @example Arsenal vs Manchester United
             */
            name: string;
            /**
             * @description Home team ID
             * @example sr:competitor:42
             */
            homeId: string;
            /**
             * @description Home team name
             * @example Arsenal
             */
            homeName: string;
            /**
             * @description Home team short name
             * @example ARS
             */
            homeShortName: string;
            /**
             * @description Home team abbreviation
             * @example ARS
             */
            homeAbbreviation: string;
            /**
             * @description Home team logo URL
             * @example https://example.com/arsenal_logo.png
             */
            homeLogoUrl: string;
            /** @description Home team jersey */
            homeJersey: string;
            /**
             * @description Home team country/region code
             * @example ENG
             */
            homeCountryCode: string;
            /**
             * @description Away team ID
             * @example sr:competitor:35
             */
            awayId: string;
            /**
             * @description Away team name
             * @example Manchester United
             */
            awayName: string;
            /**
             * @description Away team short name
             * @example MU
             */
            awayShortName: string;
            /**
             * @description Away team abbreviation
             * @example MUN
             */
            awayAbbreviation: string;
            /**
             * @description Away team logo URL
             * @example https://example.com/mu_logo.png
             */
            awayLogoUrl: string;
            /** @description Away team jersey */
            awayJersey: string;
            /**
             * @description Away team country/region code
             * @example ENG
             */
            awayCountryCode: string;
            /**
             * @description Venue ID
             * @example sr:venue:123
             */
            venueId: string;
            /**
             * @description Venue name
             * @example Emirates Stadium
             */
            venueName: string;
            /**
             * @description Referee ID
             * @example sr:referee:456
             */
            refereeId: string;
            /**
             * @description Referee name
             * @example Anthony Taylor
             */
            refereeName: string;
            /**
             * @description Match type
             * @example match
             */
            type: string;
            /**
             * @description Group ID
             * @example sr:group:789
             */
            groupId: string;
            /**
             * @description Group name
             * @example Group A
             */
            groupName: string;
            /**
             * @description Phase (e.g., group stage, knockout stage)
             * @example Group Stage
             */
            phase: string;
            /**
             * @description Other match ID
             * @example sr:match:99999
             */
            otherMatchId: string;
            /**
             * @description Tournament round
             * @example 21
             */
            tournamentRound: string;
            /**
             * Format: int64
             * @description Scheduled start time (Unix timestamp, milliseconds)
             * @example 1674408600000
             */
            scheduledTime: number;
            /**
             * Format: int64
             * @description Scheduled end time (Unix timestamp, milliseconds)
             * @example 1674415800000
             */
            scheduledEndTime: number;
            /**
             * Format: int32
             * @description Match status
             */
            status: number;
            /** @description Match status name */
            statusName: string;
            /**
             * Format: int32
             * @description Match status
             */
            matchStatus: number;
            /** @description Match status name */
            matchStatusName: string;
            sportEventStatus: components["schemas"]["com.bz.league.sports.search.api.dto.SportEventStatusDto"];
            /**
             * @description Whether has radar live odds
             * @example true
             */
            hasRadarLiveOdds: boolean;
            /**
             * @description Whether has radar pre-match odds
             * @example true
             */
            hasRadarPreMatchOdds: boolean;
            marketBatchResponse: components["schemas"]["com.bz.odds.api.dto.MarketBatchResponse"];
            /** @description Live stream list */
            streamsList: components["schemas"]["com.bz.league.sports.search.api.dto.StreamsDto"][];
        };
        "com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.VaixHotMatchesDto": {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["com.bz.league.sports.search.api.dto.VaixHotMatchesDto"][];
        };
        "com.bz.league.sports.search.api.dto.StatisticsDto": {
            yellowCards: components["schemas"]["com.bz.league.sports.search.api.dto.StatisticsScoreDto"];
            redCards: components["schemas"]["com.bz.league.sports.search.api.dto.StatisticsScoreDto"];
            yellowRedCards: components["schemas"]["com.bz.league.sports.search.api.dto.StatisticsScoreDto"];
            corners: components["schemas"]["com.bz.league.sports.search.api.dto.StatisticsScoreDto"];
            greenCards: components["schemas"]["com.bz.league.sports.search.api.dto.StatisticsScoreDto"];
        };
        "com.bz.league.sports.search.api.dto.StatisticsScoreDto": {
            /** Format: int32 */
            home: number;
            /** Format: int32 */
            away: number;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    playerDetails: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["com.bz.league.sports.search.api.request.PlayerDetailRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.PlayerDto"];
                };
            };
        };
    };
    getTournamentAggByIds: {
        parameters: {
            query: {
                /**
                 * @description 比赛URN列表
                 * @example ["sr:match:64595720"
                 */
                matchIds: string[];
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.TournamentAggMatchHitDto"];
                };
            };
        };
    };
    getTournamentAggByIdsPost: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["com.bz.league.sports.search.api.request.MatchDetailRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.TournamentAggMatchHitDto"];
                };
            };
        };
    };
    matchDetails: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["com.bz.league.sports.search.api.request.MatchDetailRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.SeasonMatchDocumentDto"];
                };
            };
        };
    };
    i18nTranslate: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["com.bz.league.sports.search.api.dto.I18nTranslateRequestDto"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.I18nTranslateResponse"];
                };
            };
        };
    };
    getSportDataVaixTopMatches: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.sports.search.api.dto.VaixTopMatchesDto"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": Record<string, never>;
                };
            };
        };
    };
    getSports: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.sports.search.api.dto.VaixSportsDto"];
                };
            };
        };
    };
    getLiveEvent: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.sports.search.api.dto.VaixHotMatchesDto"];
                };
            };
        };
    };
    getHotMatches: {
        parameters: {
            query: {
                /**
                 * @description 运动类型
                 * @example sr:sport:1
                 */
                sportId: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.sports.search.api.dto.VaixHotMatchesDto"];
                };
            };
        };
    };
    getHotCombosMatches: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.sports.recommend.api.dto.response.VaixRecommendBetDto"];
                };
            };
        };
    };
    getSportDataSportTree: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.SportTreeDto"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": Record<string, never>;
                };
            };
        };
    };
    sportRecommend: {
        parameters: {
            query: {
                /**
                 * @description 比赛状态列表,upcoming: 0, live: 1
                 * @example 0,1
                 */
                statusList: string[];
                /**
                 * @description 计划时间 (Unix timestamp in milliseconds)
                 * @example 1678886400000
                 */
                scheduledTime?: number;
                /**
                 * @description 用户ID
                 * @example 11211111121
                 */
                userId?: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.SportRecommendDto"];
                };
            };
        };
    };
    outRightTree: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.SportTreeDto"];
                };
            };
        };
    };
    algoSport: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.server.infra.algo.resp.VaixSportsResponse"];
                };
            };
        };
    };
    getBettingHighlight: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.recommend.api.dto.response.VaixRecommendBetDto"];
                };
            };
        };
    };
    outrightSearch: {
        parameters: {
            query: {
                /**
                 * @description 运动项目ID
                 * @example sr:sport:1
                 */
                sportId: string;
                /**
                 * @description 分类ID
                 * @example sr:category:1
                 */
                categoryId?: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.OutRightAggMatchHitDto"];
                };
            };
        };
    };
    matchDetail: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path: {
                /**
                 * @description 比赛的唯一标识id
                 * @example sr:match:12345678
                 */
                matchId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.SingleResponseCom.bz.league.sports.search.api.dto.SeasonMatchDocumentDto"];
                };
            };
        };
    };
    getSportDataMatchSearch: {
        parameters: {
            query: {
                /** @description 比赛搜索请求 */
                matchSearchRequest: components["schemas"]["com.bz.league.sports.search.api.request.MatchSearchRequest"];
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.TournamentAggMatchHitDto"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": Record<string, never>;
                };
            };
        };
    };
    matchPlayers: {
        parameters: {
            query: {
                /**
                 * @description 比赛的唯一标识id
                 * @example sr:match:64595720
                 */
                matchId: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.SingleResponseCom.bz.league.sports.search.api.dto.MatchPlayersDto"];
                };
            };
        };
    };
    checkMatch: {
        parameters: {
            query: {
                /**
                 * @description 运动项目ID
                 * @example sr:sport:1
                 */
                sportId: string;
                /**
                 * @description 分类ID
                 * @example sr:category:1
                 */
                categoryId?: string;
                /**
                 * @description 联赛ID
                 * @example sr:tournament:1
                 */
                tournamentId?: string;
                /**
                 * @description 比赛状态列表,upcoming: 0, live: 1
                 * @example 0,1
                 */
                statusList: string[];
                /**
                 * @description 计划时间 (Unix timestamp in milliseconds)
                 * @example 1678886400000
                 */
                scheduledTime?: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.SingleResponseCom.bz.league.sports.search.api.dto.CheckMatchDto"];
                };
            };
        };
    };
    algoSearch: {
        parameters: {
            query: {
                /**
                 * @description 用户ID
                 * @example 11211111121
                 */
                userId?: string;
                /**
                 * @description 关键字
                 * @example aaaa
                 */
                keyWord: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.server.domain.repository.SportAlgoSearchResponse"];
                };
            };
        };
    };
    algoLeague: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.server.infra.algo.resp.VaixSportsResponse"];
                };
            };
        };
    };
    getSportDataVaixV2HotMatches: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.sports.search.api.dto.VaixTopMatchesDto"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": Record<string, never>;
                };
            };
        };
    };
    getSportDataVaixPopularLeague: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.sports.search.api.dto.VaixLeagueDto"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": Record<string, never>;
                };
            };
        };
    };
    getSportDataVaixPopularEvents: {
        parameters: {
            query?: {
                /**
                 * @description 显示模式，0: standard（默认）, 1: 3-way, 2: professional
                 * @example 1
                 */
                marketMode?: number;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.sports.search.api.dto.VaixHotMatchesDto"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": Record<string, never>;
                };
            };
        };
    };
    getSportDataVaixTrendingSport: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.sports.search.api.dto.VaixSportsDto"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": Record<string, never>;
                };
            };
        };
    };
    getSportDataSearch: {
        parameters: {
            query: {
                /**
                 * @description 搜索关键词
                 * @example liverpool
                 */
                matchSearchRequest: components["schemas"]["com.bz.league.sports.search.api.request.MatchSearchRequest"];
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.SportAggTournamentHitDto"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": Record<string, never>;
                };
            };
        };
    };
    getRecommendVaixFavorite: {
        parameters: {
            query: {
                /** @description 比赛搜索请求 */
                matchSearchRequest: components["schemas"]["com.bz.league.sports.search.api.request.MatchSearchRequest"];
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description 语言 */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.VaixHotMatchesDto"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": Record<string, never>;
                };
            };
        };
    };
    createSportDataMatchGetTournamentMatchByIds: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description Client type - All /api endpoints will be restricted by gateway
                 *     Rules: [xx business]-[xx client]
                 *     BZ business:
                 *     1. Web client BZ-WEB
                 *     2. App client BZ-APP
                 *     3. Mini-program client BZ-AAPLET
                 *     For dev and test environments, can use default value in swagger: SWAGGER
                 */
                "X-Client-Type"?: string;
                /** @description Language */
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["com.bz.league.sports.search.api.request.MatchDetailRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["com.bz.common.dto.MultiResponseCom.bz.league.sports.search.api.dto.TournamentAggMatchHitDto"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": Record<string, never>;
                };
            };
        };
    };
}
export enum ApiPaths {
    playerDetails = "/api/v1/sportData/player/details",
    getTournamentAggByIds = "/api/v1/sportData/match/getTournamentAggByIds",
    getTournamentAggByIdsPost = "/api/v1/sportData/match/getTournamentAggByIds",
    matchDetails = "/api/v1/sportData/match/details",
    i18nTranslate = "/api/v1/sportData/i18n",
    getSportDataVaixTopMatches = "/api/v1/sportData/recommend/topMatches",
    getSports = "/api/v1/sportData/recommend/sports",
    getLiveEvent = "/api/v1/sportData/recommend/liveEvent",
    getHotMatches = "/api/v1/sportData/recommend/hotMatches",
    getHotCombosMatches = "/api/v1/sportData/recommend/hotCombosMatches",
    getSportDataSportTree = "/api/v1/sportData/sport/tree",
    sportRecommend = "/api/v1/sportData/sport/recommend",
    outRightTree = "/api/v1/sportData/sport/outRightTree",
    algoSport = "/api/v1/sportData/sport/algoSport",
    getBettingHighlight = "/api/v1/sportData/recommend/bettingHighlight",
    outrightSearch = "/api/v1/sportData/outright/search",
    matchDetail = "/api/v1/sportData/match/{matchId}",
    getSportDataMatchSearch = "/api/v1/sportData/match/search",
    matchPlayers = "/api/v1/sportData/match/matchPlayers",
    checkMatch = "/api/v1/sportData/match/checkMatch",
    algoSearch = "/api/v1/sportData/match/algoSearch",
    algoLeague = "/api/v1/sportData/league/algoLeague",
    getSportDataVaixV2HotMatches = "/api/v1/sportData/recommend/v2HotMatches",
    getSportDataVaixPopularLeague = "/api/v1/sportData/recommend/popularLeague",
    getSportDataVaixPopularEvents = "/api/v1/sportData/recommend/popularEvents",
    getSportDataVaixTrendingSport = "/api/v1/sportData/recommend/trendingSport",
    getSportDataSearch = "/api/v1/sportData/search",
    getRecommendVaixFavorite = "/api/v1/sportData/recommend/favorite",
    createSportDataMatchGetTournamentMatchByIds = "/api/v1/sportData/match/getTournamentMatchByIds"
}
